import type { LogEvent, LogLevel, LogSink } from "./types";

/**
 * Baseline console-sink (ADR-0011 D6). Тонка обгортка над **голим `console`**
 * (без `consola`/`loglevel`): мапа рівня → метод, структурований вивід
 * `[<source>] <message>` + санітизований context-обʼєкт.
 *
 * Подія приходить уже санітизованою (§7), тож console отримує лише безпечну
 * проекцію — БЕЗ окремого dev-raw side-channel (свідоме посилення PII-межі
 * відносно ADR-0011 D5: за межу dispatcher-а raw не виходить узагалі). Для
 * `Error` у `context.error` лишається `stack` — DevTools розгортає його.
 */
const METHOD: Record<LogLevel, (...args: unknown[]) => void> = {
  error: (...a) => console.error(...a),
  warn: (...a) => console.warn(...a),
  info: (...a) => console.info(...a),
  debug: (...a) => console.debug(...a),
};

export const consoleSink: LogSink = {
  write(event: LogEvent): void {
    const source = event.context.source ?? "app";
    METHOD[event.level](`[${source}] ${event.message}`, event.context);
  },
};
